<template>
  <sub-page title="亮证">
    <div class="show-cert-page">
      <!-- 空状态：插画 + 没有证照 -->
      <div class="empty-state">
        <img src="@/assets/icons/cert-empty.png" class="empty-img" alt="没有证照" />
        <div class="empty-text">没有证照</div>
      </div>
    </div>
  </sub-page>
</template>

<script>
import SubPage from './SubPage.vue'

export default {
  name: 'ShowCert',
  components: { SubPage }
}
</script>

<style scoped>
.show-cert-page {
  min-height: 100%;
  background: #F5F6F7;
  display: flex;
  flex-direction: column;
}
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  /* 设计稿插画位于页面上部约1/3处 */
  padding-top: calc(280 * var(--w));
}
.empty-img {
  width: calc(440 * var(--w));
  height: calc(280 * var(--w));
  object-fit: contain;
}
.empty-text {
  margin-top: calc(40 * var(--w));
  font-size: calc(36 * var(--w));
  color: #323233;
}
</style>



// WEBPACK FOOTER //
// src/pages/ShowCert.vue